import enrolments from "./enrolments.json";
import homepage from "./homepage.json";

export const en = {
  ...enrolments,
  ...homepage,
};
